import { Sikka_FAQ } from "data/faq";
let map;

export default function search(search) {
	map = new Map();
	const result = [];
	const byQuestion = searchByQuestion(search);
	const byAnswers = searchByAnswer(search);

	return result.concat(byQuestion, byAnswers);
}

const searchByQuestion = (search) => {
	let filteredFaqs = [];

	Sikka_FAQ.forEach((faq) => {
		const { question } = faq;

		if (
			question.toLowerCase().indexOf(search.toLowerCase()) !== -1 &&
			!map.has(question)
		) {
			filteredFaqs.push(faq);
			map.set(question, question);
		}
	});

	return filteredFaqs;
};

const searchByAnswer = (search) => {
	let filteredData = Sikka_FAQ.filter((faq) => {
		const { question, answer } = faq;

		const answerText = answer
			.map((val) => {
				let data = [];
				if (val.description) data.push(val.description.toLowerCase());
				if (val.list) {
					let itemArray = val.list.items
						.map((val) => val.description.toLowerCase())
						.join(" ");
					data.push(itemArray);
				}

				return [...data];
			})
			.join(" ");

		const searchWord = search.toLowerCase();

		if (map.has(question)) {
			return false;
		}
		if (answerText.indexOf(searchWord) > -1) {
			return true;
		}

		return false;
	});
	return filteredData;
};
